import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { themeColors } from "letalkui"

const useStyles = makeStyles({
	listItemButton: {
		background: colors.gray[100],
		opacity: 0.8,
		borderRadius: "8px",
		gap: "8px",
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[200])
		},
		minWidth: "64px",
		width: "64px",
		height: "64px",
		color: colors.gray[700],
		display: "flex",
		alignItems: "center",
		justifyContent: "center"
	},
	icon: {
		width: "16px",
		height: "16px"
	},
	kanbanIcon: {
		color: themeColors.getPrimaryColor(),
		width: "40px",
		height: "40px",
		display: "block"
	}
})

export default useStyles
